import { IonCard, IonImg } from '@ionic/react';

import { mergeClassNames } from '@/utils';

import GaitObservationsIllustration from '@/assets/illustrations/GaitObservationsIllustration.svg';
import HamstringAnalysisIllustration from '@/assets/illustrations/HamstringAnalysisIllustration.svg';
import KneeStabilityIllustration from '@/assets/illustrations/KneeStabilityIllustration.svg';

import styles from './SessionTypeCard.module.css';

export type SessionType = 'GO' | 'ACL' | 'Hamstring';

export interface SessionTypeCardProps {
  type: SessionType;
  selected: boolean;
  title: string;
  onSelect: (type: SessionType) => void;
}

export const SessionTypeCard = ({ type, selected, title, onSelect }: SessionTypeCardProps) => {
  return (
    <>
      <IonCard
        className={mergeClassNames(styles.card, selected ? styles.selected : '')}
        id={type}
        onClick={() => onSelect(type)}>
        <IonImg
          className={styles.illustration}
          src={
            {
              GO: GaitObservationsIllustration,
              ACL: KneeStabilityIllustration,
              Hamstring: HamstringAnalysisIllustration,
            }[type]
          }
        />

        <div className={styles.text}>{title}</div>
      </IonCard>
    </>
  );
};
